"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _UIErrorMessage = _interopRequireDefault(require("UIComponents/error/UIErrorMessage"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var UnauthorizedPage =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(UnauthorizedPage, _Component);

  function UnauthorizedPage() {
    (0, _classCallCheck2.default)(this, UnauthorizedPage);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UnauthorizedPage).apply(this, arguments));
  }

  (0, _createClass2.default)(UnauthorizedPage, [{
    key: "getSettingsLink",
    value: function getSettingsLink() {
      var portalId = _hubspot.default.get();

      return "/settings/" + portalId;
    }
  }, {
    key: "langKey",
    value: function langKey(suffix) {
      var moduleName = this.props.moduleName;
      return moduleName + ".unauthorized." + suffix;
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_UIFlex.default, {
        align: "center",
        justify: "center",
        direction: "column",
        wrap: "wrap"
      }, _react.default.createElement(_UIErrorMessage.default, {
        illustration: "lock",
        title: _react.default.createElement("h4", null, _react.default.createElement(_FormattedHTMLMessage.default, {
          message: this.langKey('title')
        }))
      }, _react.default.createElement("p", null, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: this.langKey('description')
      })), this.props.includeNextStep && _react.default.createElement("p", null, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: this.langKey('nextStep')
      })), _react.default.createElement(_UILink.default, {
        href: this.getSettingsLink()
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: this.langKey('link')
      }))));
    }
  }]);
  return UnauthorizedPage;
}(_react.Component);

UnauthorizedPage.defaultProps = {
  includeNextStep: true
};
UnauthorizedPage.propTypes = {
  includeNextStep: _react.PropTypes.bool.isRequired,
  moduleName: _react.PropTypes.string.isRequired
};
var _default = UnauthorizedPage;
exports.default = _default;
module.exports = exports.default;